import { Flex } from "rebass";
import { AiOutlinePlus } from "react-icons/ai";
const PlusButton = ({ onClick }) => {
  return (
    <Flex
      backgroundColor="#232323"
      alignContent={"center"}
      alignItems={"center"}
      padding={"10px"}
      sx={{
        border: "1px solid #454645",
        borderRadius: "50%",
        WebkitBorderTopLeftRadius: "50%",
        WebkitBorderTopRightRadius: "50%",
        WebkitBorderBottomLeftRadius: "50%",
        WebkitBorderBottomRightRadius: "50%",
        WebkitBorderRadius: "50%",
        zIndex: 1,
      }}
      onClick={onClick}
    >
      <AiOutlinePlus
        color="white"
        style={{
          width: "80px",
          height: "auto",
        }}
      />
    </Flex>
  );
};

PlusButton.defaultProps = {
  onClick: () => {},
};

export { PlusButton };
